<template lang="pug">
  .sale-cart
    .loading-menu-lock(v-if="loading")
    .list-container

      // Cart
      v-list.swipe-list
        template(v-for="( item, idx ) in cartItems")
          SwipeListTile.list-iterator(
            :key="item.id"
            @add="updateQuantity(idx, 1)"
            @substract="updateQuantity(idx, -1)"
            @delete="deleteItem(item.id)"
            @show="showItem(item)"
            :disabled="loading"
            )
            MobileCartItem(
              :item="item"
              )
          v-divider

    // Items Counter
    v-layout(wrap).item-counter.grey.lighten-2
      v-flex.xs6.text-xs-center
        span {{cartItems.length}} líneas
      v-flex.xs6.text-xs-center
        span {{cartItems.reduce((sum, itm) => sum += parseInt(itm.quantity), 0)}} productos

    v-layout(
      v-if="discountPercentage"
      wrap
      )
      v-flex.xs12.d-flex.justify-center.text-xs-center.pa-0.ma-0
        span.subheading Descuento Cliente: 
          b {{discountPercentage}}%
        // Switch for customer discount
        //div(style="width: 250px; max-width: 250px;")
          v-switch.text-xs-center(
            :label="`Aplicar dcto. cliente (${discountPercentage}%)`"
            v-model="applyDiscount"
            )

    v-layout(wrap).sale-totals
      v-flex.xs4.text-xs-center
        span IVA:
        p.subheading.font-weight-bold 
          | {{getIVA | mixFormatCurrency}}
      v-flex.xs4.text-xs-center
        span NETO:
        p.subheading.font-weight-bold
          | {{getNeto | mixFormatCurrency}}
      v-flex.xs4.text-xs-center
        span TOTAL:
        p.subheading.font-weight-bold(
          :class="totalClass"
          )
          | {{getTotal | mixFormatCurrency}}
    // Controls
    v-layout
      // Payment Type
      v-flex.xs6
        v-btn.btnPayment(
          block
          large
          color="secondary"
          :disabled="loading || !cartItems.length || !customerData.id"
          style="margin: 0px !important; border-radius: 0px !important;"
          @click="setDialogTypePayment(true)"
          ) TIPO PAGO
      // Comments
      v-flex.xs6
        v-btn.btnPayment(
          block
          large
          :outline="!commentary"
          color="secondary"
          :disabled="loading || !cartItems.length || !customerData.id"
          style="margin: 0px !important; border-radius: 0px !important;"
          @click="commentaryDialog = true"
          )
          v-icon more_horiz

    // Customer and Payment Info
    .d-flex(
      style="flex-direction: column;"
      )
      div( 
        style="justify-content: flex-start; cursor: pointer;"
        @click="loading ? '' : $router.push('/mobile/customer')"
        )
        span Cliente:
        span.font-weight-bold.mx-2(
          :class="customer.classes"
          ) {{customer.text}}
      div
        span Pago a:
        span.font-weight-bold.mx-2(
          :class="paymentTypeComp.classes"
          ) {{paymentTypeComp.text}} 

      template( v-if="isExedingCredit" )
        span.error.white--text Cupo excedido: 
          b $ {{ activeCustomerCredit.max_available_credit.toLocaleString() }}

    // Submit Button
    div.divider
    v-btn.confirm-button(
      v-if="pos_customer_credit_option_id"
      block
      :color="isQuotation ? 'info' : 'success'"
      :disabled="disableSale"
      style="margin: 0px !important; border-radius: 0px !important; height: 60px;"
      @click="confirmationSnackbar = true"
      large
      ) 
      span(v-if="!loading")
        | GENERAR {{isQuotation ? 'COTIZACIÓN' : 'PEDIDO'}}
      v-progress-circular(
        indeterminate
        v-if="loading"
        color="info"
        )

    // Snackbar
    v-snackbar(
      v-model="showSnackbar"
      :multi-line="snackMultiLine"
      :color="snackbarData.color"
      auto-height
      :timeout="0"
      )
      span(v-html="snackbarData.text")

    v-snackbar(
        v-model="confirmationSnackbar"
        multi-line
        :color="isUsingExtendedCredit || paymentTypeComp.warning ? 'amber darken-4' : 'info'"
        :timeout="0"
        )
        v-layout(wrap)
            v-flex.xs12.text-xs-center.mb-2
                span.text-xs-center.font-weight-bold(
                    :class="{caption: isUsingExtendedCredit || paymentTypeComp.warning}"
                    )
                    | Confirmar {{isQuotation ? 'Cotización' : 'Pedido'}}
                    | {{isUsingExtendedCredit || paymentTypeComp.warning ? '(require autorización)' : ''}}
            v-flex.xs6
                v-btn(
                    outline
                    @click="submitSale()"
                    ) CONFIRMAR
            v-flex.xs6
                v-btn(
                    outline
                    @click="confirmationSnackbar = false"
                    ) CANCELAR

    // Payment Methods Dialog
    v-dialog(v-model='dialogTypePayment' width='500')
      v-toolbar(color="red" dark)
        v-toolbar-title Seleccione tipo de pago
      v-card
        v-card-text
          v-layout(wrap='' align-center='')
            v-flex(xs12='' sm8='' d-flex='')
              v-select(
                :items='paymentTypes' 
                v-model="pos_customer_credit_option_id" 
                item-text="text" 
                item-value="id" 
                label='Tipo Pago'
                )
        v-divider
        v-card-actions
            v-spacer
            v-btn(color='primary' flat='' @click='setDialogTypePayment(false)')
              | Seleccionar

    // Others Dialog
    v-dialog(
      v-model="commentaryDialog"
      )
      v-card.py-3.px-2
        v-btn( block color="error" @click="commentaryDialog = false" )
            v-icon( left ) close
            | cerrar dialogo
        v-textarea(
          label="Comentario"
          v-model="commentary"
          outline
          no-resize
          ref="comment"
          )
        .d-flex.justify-center( :style="{ display: isQuotation ? 'none !important' : 'flex' }" )
          span.text-xs-right.pt-2 Despacho
          div.switch-container(
            style="width: 100px; max-width: 100px; min-width: 100px;"
            ).pl-2
            v-switch.my-0.ml-4(
            :disabled="isQuotation"
              v-model="storePickup"
              )
          span.pt-2 Retiro en Tienda
        .d-flex.justify-center
          span.text-xs-right.pt-2 Venta
          div.switch-container(
            style="width: 100px; max-width: 100px; min-width: 100px;"
            ).pl-2
            v-switch.my-0.ml-4(
              v-model="isQuotation"
              )
          span.pt-2 Cotización
        v-form(ref="quotationForm" v-if="isQuotation")
          v-layout(wrap)
            v-flex.xs12
              v-select(
                label="Vigencia"
                v-model="expiration_date"
                :items="quotationOptions"
                @input="checkQuotationDataState()"
                @change="expiration_date = $event"
                item-value="days"
                )
            v-flex.xs12
              v-text-field(
                label="Email Cliente"
                v-model="customer_email"
                :rules="[mixRules.email, mixRules.required]"
                @input="checkQuotationDataState()"
                )
</template>

<script>
import SwipeListTile from '../../components/Mobile/SwipeListTile/SwipeListTile.vue'
import MobileCartItem from './MobileCartItem.vue'
import { mapState, mapGetters, mapActions } from 'vuex'
import CurrencyUtils from '../../mixins/CurrencyUtils'
import InputValidations from '../../mixins/InputValidations'
import SaleService from '@/services/API/SaleService'
import { cloneDeep } from 'lodash'

function initialState() {
    return {
        showModal: false,
        activeItem: null,
        loading: false,
        showSnackbar: false,
        snackbarData: {
            color: 'success',
            text: '',
        },
        dialogTypePayment: false,
        commentaryDialog: false,
        quotationDataState: false,
        snackMultiLine: false,

        applyDiscount: false,

        confirmationSnackbar: false,
    }
}

export default {
    name: 'mobile-cart',
    mixins: [CurrencyUtils, InputValidations],
    data: () => initialState(),
    computed: {
        ...mapState('CartModule', {
            cartItems: state => state.items,
            getTotal: 'total',
            globalDiscount: 'globalDiscount',
        }),
        ...mapState('CustomerModule', {
            customerData: 'customerData',
            customerID: 'customerID',
            activeOfficeID: 'activeOfficeID',
            createMode: 'createMode',
        }),
        ...mapState('EmployeeModule', {
            validEmployee: 'validEmployee',
            employee: 'employee',
        }),
        ...mapGetters('TransactionModule', {
            activeTransaction: 'activeTransaction',
        }),
        ...mapGetters('CartModule', {
            getIVA: 'getIVA',
            getNeto: 'getNeto',
        }),
        ...mapGetters('AuthModule', {
            groundSellerId: 'groundSellerId',
            groundSellerCode: 'groundSellerCode',
        }),
        ...mapGetters('CustomerModule', [
            'activeCustomerEmail',
            'discountPercentage',
            'activeCustomerCredit',
        ]),
        ...mapState('SessionModule', [
            'customerCreditOptions',
            'pchPaymentConditions',
            'mobileSelectedPaymentMethod',
            'mobileCommentary',
            'mobileIsQuotation',
            'mobileStorePickup',
            'mobileExpirationDate',
            'mobileCustomerEmail',
        ]),
        items() {
            return this.cartItems.map(i => {
                return { ...i }
            })
        },
        customer() {
            if (
                this.customerData &&
                this.customerData.businessName &&
                this.customerData.id
            )
                return { classes: '', text: this.customerData.businessName }
            return { classes: 'red--text', text: 'NO ASIGNADO' }
        },
        paymentTypeComp() {
            if (
                this.pos_customer_credit_option_id ||
                this.pos_customer_credit_option_id === 0
            ) {
                let type = this.paymentTypes.find(
                    p => p.id === this.pos_customer_credit_option_id
                )
                if (!type)
                    return {
                        classes: 'red--text',
                        text: 'MEDIO DE PAGO NO HABILITADO',
                    }
                let pc = this.pchPaymentConditions.find(
                    ({ id }) => id === this.pchPaymentCondition
                )
                let active = this.pchPaymentConditions.find(
                    ({ id }) => id === this.pos_customer_credit_option_id
                )
                if (pc && active && pc.days < active.days)
                    return {
                        classes: 'amber--text text--darken-3',
                        text: type.text,
                        warning: true,
                    }
                return { classes: '', text: type.text }
            } else {
                return { classes: 'red--text', text: 'NO ASIGNADO' }
            }
        },
        submitData() {
            let sale = {}
            sale.customer_id = this.customerID
            sale.g_core_business_sii_id = this.customerData.active_core_business_id
            sale.default_branch_office = this.activeOfficeID
            sale.default_branch_office_id = this.activeOfficeID
            sale.default_branch_office_index = this.createMode ? 0 : null
            for (var prop in sale.customer) {
                if (sale.customer.hasOwnProperty(prop)) {
                    if (!sale.customer[prop]) sale.customer[prop] = '-'
                }
            }
            sale.pos_sale_type = this.isQuotation ? 3 : 2
            sale.global_discount = this.globalDiscount.percentage_discount
            sale.description = this.description || 'vacío'
            sale.requester_employee_id = this.validEmployee && this.employee.id
            sale.employee_id = this.validEmployee && this.employee.id
            sale.seller_user_id = this.groundSellerId
            sale.seller_user_code = this.groundSellerCode
            sale.supervisor_user_id = null
            sale.supervisor_user_code = null
            sale.pos_origin_sale_id = 2
            sale.flag_store_pickup = false

            if (this.isQuotation) {
                sale.customer_email = this.customer_email
                sale.expiration_date = this.quotationExpiration
            }
            try {
                sale.pos_customer_credit_option_id = this.customerCreditOptions.find(
                    o =>
                        o.days ===
                        this.pchPaymentConditions.find(
                            p => p.id === this.pos_customer_credit_option_id
                        ).days
                ).id
            } catch (e) {
                sale.pos_customer_credit_option_id === 'ERROR'
            }
            /*sale.pos_customer_credit_option_id = this.getPaymentCreditId(*/
            /*this.pos_customer_credit_option_id*/
            /*)*/
            if (this.globalDiscount.amount_discount) {
                let sum = 0
                this.items.forEach(item => (sum += item.subtotal))
                sale.global_discount =
                    (100 * this.globalDiscount.amount_discount) / sum
            }
            if (!sale.global_discount) sale.global_discount = 0
            sale.total = Math.round(this.getTotal)
            sale.sale_detail = this.items.map(item => {
                let price = () => {
                    if ([2, 3].includes(this.activeTransaction.id))
                        return (
                            item.backend_invoice_price ||
                            item.discounted_price ||
                            item.sale_price
                        )
                    return item.discounted_price || item.sale_price
                }
                return {
                    product_id: item.id,
                    quantity: parseFloat(item.quantity),
                    // price: item.discounted_price || item.sale_price,
                    price: Math.round(price()),
                    discount:
                        item.lineDiscount &&
                        item.lineDiscount.percentage_discount
                            ? item.lineDiscount.percentage_discount
                            : 0, //Descuento por porcentaje
                    discount_unit_price:
                        item.lineDiscount &&
                        item.lineDiscount.unit_price_discount
                            ? item.lineDiscount.unit_price_discount
                            : 0,
                    wh_warehouse_id: item.active_warehouse,
                }
            })
            sale.global_discount_amount = 0
            return sale
        },
        paymentTypes() {
            return cloneDeep(this.pchPaymentConditions)
                .sort((a, b) => a.days - b.days)
                .filter(({ days }) =>
                    this.customerCreditOptions.some(o => o.days === days)
                )
                .map(({ id, type }) => ({
                    id,
                    text: type,
                }))
            /*
                .filter(
                    this.pchPaymentCondition || this.pchPaymentCondition === 0
                        ? ({ days }) => {
                              let pc = this.pchPaymentConditions.find(
                                  ({ id }) => id === this.pchPaymentCondition
                              )
                              if (pc && pc.days) {
                                  return days <= pc.days
                              }
                              return true
                          }
                        : () => true
                )
                */
            // return [
            //     { id: 4, text: 'Contra Entrega', days: 1 },
            //     { id: 5, text: '5 días', days: 5 },
            //     { id: 6, text: '7 días', days: 7 },
            //     { id: 7, text: '10 días', days: 10 },
            //     { id: 0, text: '15 días', days: 15 },
            //     { id: 1, text: '30 días', days: 30 },
            // ]
        },
        quotationOptions() {
            return [
                { id: 4, text: 'Contra Entrega', days: 1 },
                { id: 5, text: '5 días', days: 5 },
                { id: 6, text: '7 días', days: 7 },
                { id: 7, text: '10 días', days: 10 },
                { id: 0, text: '15 días', days: 15 },
                { id: 1, text: '30 días', days: 30 },
            ]
        },
        pchPaymentCondition() {
            return this.customerData.pch_payment_condition_id
        },
        quotationExpireOptions() {
            return this.paymentTypes.map(i => {
                if (i.id === 4) i.text = '1 día'
                return i
            })
        },
        quotationExpiration() {
            return this.getQuotationDays(this.expiration_date)
        },
        totalClass() {
            if (
                !this.activeCustomerCredit ||
                !this.activeCustomerCredit.max_customer_credit
            )
                return []
            if (this.isExedingCredit) return ['red--text', 'text--darken-2']
            if (this.isUsingExtendedCredit)
                return ['amber--text', 'text--darken-4']
            return []
        },
        disableSale() {
            return (
                this.loading ||
                !this.cartItems.length ||
                !this.customerData.id ||
                (this.isQuotation && !this.quotationDataState) ||
                (!this.isQuotation && this.isExedingCredit)
            )
        },
        isUsingExtendedCredit() {
            return this.activeCustomerCredit &&
                this.activeCustomerCredit.max_available_credit
                ? this.getTotal >
                      this.activeCustomerCredit.available_customer_credit
                : false
        },
        isExedingCredit() {
            return this.activeCustomerCredit &&
                this.activeCustomerCredit.max_available_credit
                ? this.getTotal > this.activeCustomerCredit.max_available_credit
                : false
        },
        pos_customer_credit_option_id: {
            get() {
                return this.mobileSelectedPaymentMethod
            },
            set(v) {
                this.setMobileSelectedPaymentMethod(v)
            },
        },
        commentary: {
            get() {
                return this.mobileCommentary
            },
            set(v) {
                this.setMobileCommentary(v)
            },
        },
        isQuotation: {
            get() {
                return this.mobileIsQuotation
            },
            set(v) {
                this.setMobileIsQuotation(v)
            },
        },
        expiration_date: {
            get() {
                return this.mobileExpirationDate
            },
            set(v) {
                this.setMobileExpirationDate(v)
            },
        },
        customer_email: {
            get() {
                return this.mobileCustomerEmail
            },
            set(v) {
                this.setMobileCustomerEmail(v)
            },
        },
        storePickup: {
            get() {
                return this.mobileStorePickup
            },
            set(v) {
                this.setMobileStorePickup(v)
            },
        },
    },
    methods: {
        checkQuotationDataState() {
            if (!this.$refs.quotationForm.validate())
                return (this.quotationDataState = false)
            this.quotationDataState =
                this.customer_email && this.expiration_date
        },
        clearState() {
            this.resetCart()
            this.resetCustomer()
            this.clearMobileData()
            Object.assign(this.$data, initialState())
        },
        ...mapActions('CartModule', {
            setCartItems: 'setCartItems',
            setActiveMobileItemId: 'setActiveMobileItemId',
            resetCart: 'resetState',
            setGlobalDiscount: 'setGlobalDiscount',
        }),
        ...mapActions('CustomerModule', {
            resetCustomer: 'resetState',
        }),
        ...mapActions('SessionModule', [
            'setMobileCommentary',
            'setMobileIsQuotation',
            'setMobileExpirationDate',
            'setMobileStorePickup',
            'setMobileCustomerEmail',
            'setMobileSelectedPaymentMethod',
            'clearMobileData',
        ]),
        updateQuantity(idx, val) {
            if (this.loading) return
            let items = cloneDeep(this.items)
            items[idx].quantity = parseInt(items[idx].quantity) + val
            if (this.validateQuantity(items[idx])) this.setCartItems(items)
        },
        deleteItem(id) {
            if (this.loading) return
            let items = this.items
            items = items.filter(i => i.id !== id)
            this.setCartItems(items)
        },
        validateQuantity(itm) {
            if (!itm.stock) return false
            if (!itm.quantity || itm.quantity < 1) return false
            if (itm.quantity > itm.stock) return false
            return true
        },
        showItem(item) {
            if (this.loading) return
            this.setActiveMobileItemId(item.id)
            this.$router.push('/mobile/details')
        },
        submitSale: async function(code = null) {
            //this.showSpinner('orange')
            this.confirmationSnackbar = false
            if (this.loading) return
            if (this.submitData.pch_payment_condition_id === 'ERROR') {
                this.snackbarData.color = 'error'
                this.snackbarData.text =
                    'Medio de pago seleccionado no admitido'
                this.showSnackbar = true
                this.snackMultiLine = true
                setTimeout(this.clearSnackbar, 7000)
                return
            }
            if (!this.submitData.g_core_business_sii_id) {
                this.snackbarData.color = 'error'
                this.snackbarData.text =
                    'No ha seleccionado giro para el cliente'
                this.showSnackbar = true
                this.snackMultiLine = true
                setTimeout(this.clearSnackbar, 7000)
                return
            }
            if (
                !this.submitData.default_branch_office ||
                !this.submitData.default_branch_office_id
            ) {
                this.snackbarData.color = 'error'
                this.snackbarData.text =
                    'Debe seleccionar una sucursal para el cliente'
                this.showSnackbar = true
                this.snackMultiLine = true
                setTimeout(this.clearSnackbar, 7000)
                return
            }
            if (this.submitData.sale_detail.length > 20 && !this.isQuotation) {
                this.snackbarData.color = 'error'
                this.snackbarData.text =
                    'No puede generar pedidos de mas de 20 líneas'
                this.showSnackbar = true
                this.snackMultiLine = true
                setTimeout(this.clearSnackbar, 7000)
                return
            }

            this.loading = true
            let transType = this.submitData.pos_sale_type
            this.submitData.supervisorCode = null
            this.submitData.total = this.getTotal
            if (this.isQuotation)
                this.submitData.quotation_comment = this.commentary
            else this.submitData.sale_comment = this.commentary
            if (this.storePickup)
                this.submitData.sale_comment =
                    'COMENTARIO DEL SISTEMA: RETIRO EN TIENDA \n' +
                    this.commentary
            let response = {}
            try {
                response = await SaleService.store(this.submitData)
            } catch (e) {
                //TODO: handle error
                this.loading = false
                this.snackbarData.color = 'error'
                this.snackbarData.text =
                    e && e.response && e.response.data && e.response.data.error
                        ? e.response.data.error
                        : e &&
                          e.response &&
                          e.response.data &&
                          e.response.data.message
                            ? e.response.data.message
                            : 'Ha ocurrid un error'
                this.showSnackbar = true
                this.snackMultiLine = true
                setTimeout(this.clearSnackbar, 7000)
                return
            }
            if (
                [200, 201, 'success'].includes(
                    response.status
                ) /* response.data.http_status_code === 201 */
            ) {
                //TODO: Handle  Success

                this.loading = false
                this.clearState()

                let hasCriticalStock =
                    response.data.critical_stock_info === undefined
                        ? false
                        : true

                if (hasCriticalStock) {
                    this.snackbarData.color = 'success'
                    this.snackbarData.text =
                        'Estimado vendedor de terreno,<br>' +
                        ' es posible que bodega no cuente con el stock necesario para:<br>' +
                        this.getStringNameProductsLowStock(
                            response.data.critical_stock_info
                        ) +
                        ' por lo que es importante que se comuniquen con Bodega y así asegurar el despacho del pedido'
                    this.showSnackbar = true
                    this.snackMultiLine = true
                    setTimeout(this.clearSnackbar, 15200)
                } else {
                    this.snackbarData.color = this.isQuotation
                        ? 'info'
                        : 'success'
                    this.snackbarData.text = `${
                        this.isQuotation
                            ? 'Cotización Generada'
                            : 'Pedido generado'
                    } extiosamente`

                    this.showSnackbar = true

                    setTimeout(this.clearSnackbar, 3200)
                }
                this.snackMultiLine = false

                //lanzar alert aqui.
            } else {
                //TODO: Handle Error
                this.loading = false
                this.snackbarData.color = 'error'
                this.snackbarData.text =
                    response && response.data && response.data.error
                        ? response.data.error
                        : response && response.data && response.data.message
                            ? response.data.message
                            : 'Ha ocurrido un error'
                this.showSnackbar = true
                this.snackMultiLine = true
                setTimeout(this.clearSnackbar, 7000)
            }
        },
        clearSnackbar() {
            this.showSnackbar = false
            this.snackbarData = {
                color: 'success',
                text: '',
            }
        },
        /*
         */
        setDialogTypePayment(val) {
            this.dialogTypePayment = val
        },
        /*
         */
        getPaymentCreditId(id) {
            let payment = this.paymentTypes.find(p => p.id === id)
            return payment.realId
        },
        getQuotationDays(days) {
            let date = new Date()
            date.setDate(date.getDate() + days)
            let dd = date.getDate()
            if (('' + dd).length === 1) dd = '0' + dd
            let mm = date.getMonth() + 1
            if (('' + mm).length === 1) mm = '0' + mm
            let yyyy = date.getFullYear()
            return `${yyyy}-${mm}-${dd}`
        },
        /*
         */
        getStringNameProductsLowStock(arrCriticProducts) {
            let arrName = arrCriticProducts.map(critic => {
                return critic.wh_product_name
            })
            let stringNames = arrName.toString().replace(',', '<br>')
            return stringNames
        },
    },
    watch: {
        showModal(v) {
            if (!v) this.activeItem = null
        },
        pchPaymentCondition: {
            handler(v) {
                if (!this.pos_customer_credit_option_id)
                    this.pos_customer_credit_option_id = v
            },
            immediate: true,
        },
        activeCustomerEmail(v) {
            if (!this.customer_email) this.customer_email = v
        },
        commentaryDialog(v) {
            if (v) this.checkQuotationDataState()
        },
        isQuotation(v) {
            this.$nextTick(() => (v ? this.checkQuotationDataState() : ''))
        },
        // Disable for discount switch
        discountPercentage: {
            immediate: true,
            handler(v) {
                if (v) {
                    this.setGlobalDiscount({
                        percentage_discount: this.discountPercentage,
                        amount_discount: null,
                    })
                } else {
                    this.setGlobalDiscount({
                        percentage_discount: null,
                        amount_discount: null,
                    })
                }
            },
        },
        /* Enable if switch required for customer discounts
        applyDiscount(v) {
            if (v && this.discountPercentage) {
                this.setGlobalDiscount({
                    percentage_discount: this.discountPercentage,
                    amount_discount: null,
                })
            } else {
                this.setGlobalDiscount({
                    percentage_discount: null,
                    amount_discount: null,
                })
            }
        },
        */
    },
    components: { SwipeListTile, MobileCartItem },
    mounted() {
        if (this.activeCustomerEmail && !this.customer_email)
            this.customer_email = this.activeCustomerEmail
    },
}
</script>

<style lang="scss" scoped>
.sale-cart {
    .list-container {
        height: calc(100vh - 205px);
        .swipe-list {
            margin: 0px;
            padding: 0px;
            max-height: 100%;
            max-width: 100%;
            overflow-x: hidden;
            overflow-y: scroll;
        }
    }
    .item-counter {
        height: 27px;
        padding-top: 2px;
    }
    .sale-totals {
        padding-top: 8px;
        height: 61px;
        padding-left: 5px;
        padding-right: 5px;
    }
}
.divider {
    height: 10px;
}
.btnPayment {
    margin-top: 5px;
}
.loading-menu-lock {
    width: 100vw;
    height: 56px;
    background-color: rgba($color: #aaa, $alpha: 0.3);
    position: fixed;
    top: 0px;
}
</style>
